import { useQuery } from '@tanstack/react-query';
import { getPortfolio } from '../processes.api';
import type { ProcessFilterValues } from '../procesLijsten';

/** Server-state for the order-portfolio steunlaag (Story 5.1, FR12); `kolommen` = `sort`/`pageSize` uit de lijststand. */
export function usePortfolio(filters: ProcessFilterValues = {}, page = 1, kolommen?: Record<string, string>) {
  return useQuery({
    queryKey: ['processes', 'portfolio', filters, page, kolommen],
    queryFn: () => getPortfolio(filters, page, kolommen),
    staleTime: 30 * 1000,
  });
}
